import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Loader from 'components/loader';
import NotFound from 'components/not-found';
import TextInput from 'components/text-input';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import DottedList from 'components/dotted-list';

import useBoundStore from 'store';
import { SellApartmentFlowPaths } from 'routes';
import useApartmentSaleInfo from 'api/hooks/use-apartment-sale-info';
import { formatArea, formatRoomsWordWithApartment, toMeters } from 'lib/utils';

import styles from './styles.module.scss';

const InputApartmentNumber: React.FC = () => {
  const navigate = useNavigate();

  const selectedSellComplex = useBoundStore((s) => s.selectedSellComplex);
  const selectedSellBuilding = useBoundStore((s) => s.selectedSellBuilding);
  const setSellApartmentNumber = useBoundStore((s) => s.setSellApartmentNumber);

  const [apartmentNumber, setApartmentNumber] = useState('');

  const { apartmentSellInfo, isLoading, error } = useApartmentSaleInfo(
    selectedSellBuilding.id,
    apartmentNumber,
  );

  const canProceed = !!apartmentSellInfo && !!apartmentNumber;

  const buttons: ButtonProps[] = [
    {
      label: 'Продолжить',
      disabled: !canProceed,
      onClick: () => {
        setSellApartmentNumber(apartmentNumber);
        navigate(SellApartmentFlowPaths.inputApartmentPrice);
      },
    },
  ];

  return (
    <BaseScreen
      padContent
      title='Выберите квартиру'
      buttons={buttons}
      onBackButtonClick={() => navigate(SellApartmentFlowPaths.chooseBuilding)}
      floatingButtons={false}
    >
      <div className={styles.complex}>ЖК</div>

      <div className={styles.inputsContainer}>
        <TextInput tall value={selectedSellComplex.title} disabled />
        <TextInput tall value={selectedSellBuilding.title} disabled />
        <TextInput
          tall
          value={apartmentNumber}
          placeholder='Номер квартиры'
          onChange={setApartmentNumber}
        />
      </div>

      <div className={styles.apartmentInfo}>
        {isLoading ? (
          <Loader size={40} />
        ) : apartmentSellInfo ? (
          <DottedList
            header='Данные о квартире'
            items={[
              {
                label: 'Тип квартиры',
                value: formatRoomsWordWithApartment(apartmentSellInfo.roomCount),
              },
              {
                label: 'Этаж',
                value: apartmentSellInfo.floor,
              },
              {
                label: 'Общая площадь',
                value: formatArea(apartmentSellInfo.areaInSqM),
              },
              {
                label: 'Высота потолка',
                value: toMeters(apartmentSellInfo.ceilingHeight),
              },
            ]}
          />
        ) : error ? (
          <NotFound message={error} />
        ) : null}
      </div>
    </BaseScreen>
  );
};

export default InputApartmentNumber;
